import { z } from 'zod';
export const WorkerConfigSchema = z.object({
    environment: z.enum(['development', 'staging', 'production']),
    clerkPublishableKey: z.string(),
    stripePublishableKey: z.string(),
    sentryDsn: z.string().optional(),
});
export const WebConfigSchema = z.object({
    apiBaseUrl: z.string().url(),
    clerkPublishableKey: z.string(),
    stripePublishableKey: z.string(),
    sentryDsn: z.string().optional(),
    environment: z.enum(['development', 'staging', 'production']),
});
export const McpConfigSchema = z.object({
    apiBaseUrl: z.string().url(),
    apiKey: z.string().optional(),
    timeout: z.number().int().positive().default(30000),
});
//# sourceMappingURL=config.js.map